import { useEffect } from 'react';
import type { AllocationsForLso } from 'src/apis/lng-marketing/types';
import type { LngOfferDetailsRequest } from 'src/apis/lng-marketing/use-lng-offer-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  lngOfferDetails?: LngOfferDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalLngGetAllocationsForLso({
  lngOfferDetails,
}: HookOptions) {
  const allocations = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) => {
      return axios.request<AllocationsForLso>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lngOfferDetails?.response) return;
    if (!lngOfferDetails.response.data._links.getAllocationsForLso) return;
    allocations.execute({
      url: lngOfferDetails.response.data._links.getAllocationsForLso.href,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lngOfferDetails?.response]);

  // not available on stage
  if (!lngOfferDetails) return;

  // no allocations (or not allowed to get it)
  if (
    lngOfferDetails.response &&
    !lngOfferDetails.response.data._links.getAllocationsForLso
  )
    return;

  return allocations;
}

export type LngGetAllocationsForLsoRequest = ReturnType<
  typeof useOptionalLngGetAllocationsForLso
>;
